export default "__VITE_ASSET__eL7ggYCL__"